import { Component, inject } from '@angular/core';
import {
  GcCheckboxComponent,
  GcLoadingSpinnerComponent,
  GcModalComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import {
  ModalStates,
  ProjectCompletionModalService,
} from '../../service/project-completion-modal.service';

@Component({
  selector: 'app-project-completion-modal',
  imports: [
    GcModalComponent,
    IpoTranslatePipe,
    GcTextComponent,
    GcCheckboxComponent,
    GcLoadingSpinnerComponent,
  ],
  templateUrl: './project-completion-modal.component.html',
  styleUrl: './project-completion-modal.component.scss',
})
export class ProjectCompletionModalComponent {
  private readonly projectCompletionModalService = inject(
    ProjectCompletionModalService,
  );

  selectedProject = this.projectCompletionModalService.selectedProject;
  modalState = this.projectCompletionModalService.modalState;

  checkboxChecked = false;

  modalStates = ModalStates;

  toggleCheckbox() {
    this.checkboxChecked = !this.checkboxChecked;
  }

  handleOnClickPrimaryButton() {
    const projectId = this.selectedProject()?.id;
    if (this.modalState() === this.modalStates.ACCEPT && projectId) {
      this.projectCompletionModalService.markProjectAsComplete(projectId);
    } else {
      this.closeModal();
    }
  }

  closeModal() {
    this.projectCompletionModalService.setIsModalOpen(false);
  }
}

@Component({
  selector: 'app-project-modal-completion',
  template: 'complete',
})
export class MockedProjectModalCompletionComponent {}
